import { render, staticRenderFns } from "./partner-registry.vue?vue&type=template&id=08f6e848&scoped=true&"
import script from "./partner-registry.ts?vue&type=script&lang=ts&"
export * from "./partner-registry.ts?vue&type=script&lang=ts&"
import style0 from "./partner-registry.scss?vue&type=style&index=0&id=08f6e848&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6e848",
  null
  
)

export default component.exports